import * as React from "react";
import { Fragment, FunctionComponent, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//MUI Core Components
import AddIcon from "@mui/icons-material/Add"

//Types
import { ICommentsPane } from "@/@types/components/MapSidebarPanes";
import ModelTable from "@/ui/Table/ModelTable";
import dataController from "@/lib/dataController";
import modelComments from "@/models/komentari";
import { DCRecord } from "@/@types/lib/dataController";
import TableButton from "@/ui/Table/ActionButtons/TableButton";
import DialogContext from "@/ui/DialogContext/DialogContext";
import CommentShapeDialog from "@/views/Komentari/CommentShapeDialog";
import MapContext from "../Map/MapContext";
import { Extent } from "ol/extent";
import { Box } from "@mui/material";

const CommentsPane: FunctionComponent<ICommentsPane> = (props) => {
  const { t } = useTranslation();
  const { changeDrawType, drawType, records } = props;
  const dc = new dataController(modelComments);
  const dialogContext = useContext(DialogContext);
  const mapContext = useContext(MapContext);

  const handleAddComment = () => {
    dialogContext.showDialog(CommentShapeDialog, {
      drawType: drawType,
      changeDrawType: changeDrawType,
    });
  };

  function handleRowAction(action: string, id: number) {
    const record = records.find((x: DCRecord) => x.id === id);
    if (!record) return

    switch (action) {
      case "show_on_map":
        if (record.geom) {
          //@ts-ignore
          handleShowOnMap((record.geom as OlFeature).getGeometry().getExtent() as Extent);
        }
        break;
    }
  }
      
  function handleShowOnMap(extent: Extent) {
    if (mapContext?.map) {
      const v = mapContext.map.getView();
      v.fit(extent, { padding: [20, 20, 20, 220], duration: 1000, maxZoom: 19 })
    }
  }

  return (
    <Fragment>
      <Box sx={{
        height: "88%"
      }}>
          <ModelTable
            key={`tblid-${records.length}`}
            dc={dc}
            records={records}
            allowSelection="none"
            title={""}
            forceIconButtons
            allowAdd={true}
            handleAdd={handleAddComment}
            allowRowAction={() => true} 
            onRowAction={handleRowAction}   
            initialPageSize={25}
            viewName="default"
            // allowRowsPerPageSelection={true}
            // trackTableState={true}
            // disableControls={false}
            // displayHeader={true}
            // paginationPosition="bottom"
            // gotoFirstPageOnSelect={false}
          >
          </ModelTable>
        </Box>
    </Fragment>
  );
};

export default CommentsPane;
